import { createFileRoute } from "@tanstack/react-router";
import KetamineOverviewPage from "@/pages/KetamineOverviewPage";
export const Route = createFileRoute("/ketamine-treatment-coral-springs-fl")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        {
          title:
            "IV Ketamine Infusion Therapy Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          name: "description",
          content:
            "Rapid-acting IV Ketamine infusion therapy in Coral Springs, FL for severe depression, anxiety, PTSD, OCD, bipolar depression & chronic pain conditions.",
        },
        {
          property: "og:title",
          content:
            "IV Ketamine Infusion Therapy Coral Springs, FL | Neuro Wellness TMS",
        },
        {
          property: "og:description",
          content:
            "Rapid-acting IV Ketamine infusion therapy in Coral Springs, FL for severe depression, anxiety, PTSD, OCD, bipolar depression & chronic pain conditions.",
        },
        {
          property: "og:url",
          content:
            "https://neurowellnesstms.com/ketamine-treatment-coral-springs-fl",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/ketamine-treatment-coral-springs-fl",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <KetamineOverviewPage />;
}
